import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { Box, Toolbar } from "@mui/material";
import Drawer from "./Drawer";
import Header from "./Header";
import { openDrawer } from "store/reducers/menu";
import { useDynamicBreakpoints } from "../../utils/breakpointUtils";
import SystemBanner from "../../components/Banner/SystemBanner";

const MainLayout = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [bannerDismissed, setBannerDismissed] = useState(false);

    const user = JSON.parse(localStorage.getItem("user"));
    const isUser = user && user?.role === "";
    const { drawerOpen } = useSelector((state) => state.menu);
    const { isLoggedIn } = useSelector((state) => state.auth);
    const { tenancyId } = useSelector((state) => state.tenancy);
    
    // Check if banner has been dismissed
    useEffect(() => {
        const dismissed = localStorage.getItem('deliverabilityBannerDismissed');
        setBannerDismissed(dismissed === 'true');
    }, []);
    
    const handleBannerDismiss = () => {
        localStorage.setItem('deliverabilityBannerDismissed', 'true');
        localStorage.setItem('deliverabilityBannerDismissedTimestamp', Date.now().toString());
        setBannerDismissed(true);
    };
    
    // Show banner on specific pages, but not for tenancy IDs 404 and 1148, and not if dismissed
    const bannerPages = ['/users', '/on-demand', '/journeybuilder', '/packs'];
    const showBanner = bannerPages.includes(location.pathname) && tenancyId !== '404' && tenancyId !== '1148' && !bannerDismissed;

    const { matchDownSM, matchDownMD, matchDownLG } = useDynamicBreakpoints(drawerOpen);

    const handleDrawerToggle = () => {
        dispatch(openDrawer({ drawerOpen: !drawerOpen }));
    };

    useEffect(() => {
        // Only redirect if not logged in and not already navigating to login
        if (!isLoggedIn && location.pathname !== '/login') {
            navigate("/login");
        }
    }, [isLoggedIn, navigate, location.pathname]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 800 && drawerOpen) {
                dispatch(openDrawer({ drawerOpen: false }));
            }
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [drawerOpen, dispatch]);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", minHeight: "100vh", paddingTop: showBanner ? 'var(--banner-height, 0px)' : 0 }}>

            {/* temporarily removed banner 
            <SystemBanner
                message="We have recently seen some issues sending Phishing Simulations which have now been resolved. If you believe you have been affected please contact Boxphish support."
                show={showBanner}
                onDismiss={handleBannerDismiss}
            />*/}

            <Box>
                <Header open={drawerOpen} showBanner={showBanner} />
            </Box>

            <Box sx={{ display: "flex", width: "100%", bgcolor: 'background.default', flex: 1, position: 'relative' }}>
                <Drawer open={drawerOpen} handleDrawerToggle={handleDrawerToggle} showBanner={showBanner} />

                <Box component="main" sx={{ width: drawerOpen ? "calc(100% - 260px)" : "100%", flexGrow: 1, p: { xs: 2, sm: 3 }, mt: -2 }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

export default MainLayout;